import { render, staticRenderFns } from "./customerForm.vue?vue&type=template&id=7c21a362&"
import script from "./customerForm.vue?vue&type=script&lang=js&"
export * from "./customerForm.vue?vue&type=script&lang=js&"
import style0 from "./customerForm.vue?vue&type=style&index=0&id=7c21a362&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports